import { FC, ReactNode } from "react";
import { HeaderTitle } from "./styled";

interface HeaderProps {
    className?: string;
    clubTitle?: string;
    timeline?: ReactNode;
    rightSideElements?: ReactNode;
    onLogoClick?: () => void;
}

export const Header: FC<HeaderProps> = ({
    className = "",
    clubTitle,
    timeline,
    onLogoClick,
    rightSideElements,
}) => {
    const classNames = "hidden sm:block w-full bg-white/95 py-4" + (className ? ` ${className}` : "");
    return (
        <header className={classNames}>
            <div className="flex flex-row justify-between items-center max-w-[980px] mx-auto">
                <div className="flex flex-row items-center justify-start gap-6 w-full">
                    <div onClick={onLogoClick} className="transition-all hover:scale-105 cursor-pointer">
                        <img src="https://academy.fcrodina.com/i/logo.png" alt="ФК Родина" className="h-28 min-w-28" />
                    </div>
                    <div>
                        <HeaderTitle className="text-5xl font-bold text-sky-900">{clubTitle}</HeaderTitle>
                        {timeline}
                    </div>
                </div>
                <div>
                    {rightSideElements}
                </div>
            </div>
        </header>
    );
};